import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import 'react-notifications-component/dist/theme.css'
// @ts-ignore
import SmartBanner from 'smart-app-banner/dist/smart-app-banner'
import { ReactNotifications } from 'react-notifications-component'
import { Helmet } from 'react-helmet'

import { Header } from '@src/components/Header/Header'
import {
  selectAppIsEditName,
  selectAppIsHeader,
  selectAppIsInitialized,
  selectAppPageTitle,
} from '@src/store/ducks/app/selectors'
import { Preloader } from '@src/components/common/Preloader/Preloader'
import { AppDispatch } from '@src/store/store'
import { fetchMe, getMessages } from '@src/store/ducks/app/thunks'
import { changeFio, getAccounts, getMessagesForUser } from '@src/store/ducks/user/thunks'
import { selectUserCurrentAddresses, selectUserInfo } from '@src/store/ducks/user/selectors'
import { selectIsAuth } from '@src/store/ducks/auth/selectors'
import { useHistory } from 'react-router-dom'
import useQuery from '@src/hooks/useQuery'
import { setIsEditName, setIsInitialized, setPageTitle } from '@src/store/ducks/app/reducer'
import { Form, Formik } from 'formik'
import { FieldFormik } from '@src/components/common/FieldFormik/FieldFormik'
import { Button } from '@src/components/Button/Button'
import { Modal } from './components/common/Modal/Modal'
import { Routes } from './routes/routes'

export const App = () => {
  const dispatch = useDispatch<AppDispatch>()
  const history = useHistory()
  const isInitialized = useSelector(selectAppIsInitialized)
  const currentAddresses = useSelector(selectUserCurrentAddresses)
  const isAuth = useSelector(selectIsAuth)
  const pagTitle = useSelector(selectAppPageTitle)
  const isHeader = useSelector(selectAppIsHeader)
  const isTv = useQuery('tv')
  const successPayment = useQuery('successPayment')
  const user = useSelector(selectUserInfo)
  const isEditName = useSelector(selectAppIsEditName)

  useEffect(() => {
    if (!isTv) {
      const s1 = document.createElement('script')
      const s0 = document.getElementsByTagName('script')[0]
      s1.async = true
      s1.src = 'https://embed.tawk.to/5f63d35a4704467e89eff820/default'
      s1.charset = 'UTF-8'
      s1.setAttribute('crossorigin', '*')
      // @ts-ignore
      s0.parentNode.insertBefore(s1, s0)

      // eslint-disable-next-line no-new
      new SmartBanner({
        daysHidden: 15, // days to hide banner after close button is clicked (defaults to 15)
        daysReminder: 90, // days to hide banner after "VIEW" button is clicked (defaults to 90)
        appStoreLanguage: 'by', // language code for the App Store (defaults to user's browser language)
        title: 'Скачать мобильное приложение',
        author: '',
        button: 'Скачать',
        price: {
          ios: 'FREE',
          android: 'FREE',
          windows: 'FREE',
        },
        // theme: 'ios',
        icon: '/app.webp',

        // , theme: '' // put platform type ('ios', 'android', etc.) here to force single theme on all device
        // , icon: '' // full path to icon image if not using website icon image
        // , force: 'ios' // Uncomment for platform emulation
      })
    }
  }, [isTv])

  useEffect(() => {
    if (successPayment === 'true') {
      // @ts-ignore
      if (window?.ReactNativeWebView?.postMessage) {
        // @ts-ignore
        window.ReactNativeWebView.postMessage('close')
      }
    }
  }, [successPayment])
  useEffect(() => {
    console.log(currentAddresses, isAuth)
    if (currentAddresses && isAuth) {
      dispatch(getMessagesForUser())
    }
    // dispatch(getMessagesForUser())
    dispatch(setPageTitle('Сообщения | Личный кабинет для абонентов КОСМОС Телеком'))
  }, [currentAddresses, dispatch, isAuth])

  useEffect(() => {
    dispatch(getMessages())

    if (!isTv) {
      dispatch(fetchMe())
    } else {
      dispatch(setIsInitialized())
    }
  }, [dispatch, isTv])

  useEffect(() => {
    if (!currentAddresses && isAuth) {
      dispatch(getAccounts())
    }
  }, [dispatch, currentAddresses, isAuth])

  useEffect(() => {
    history.listen(() => {
      window.scrollTo(0, 0)
    })
  }, [history])

  return (
    <div className="App">
      <Helmet>
        <title>{pagTitle}</title>
      </Helmet>
      <ReactNotifications />
      {isHeader && !isTv && <Header />}

      <Preloader center loading={!isInitialized}>
        <Routes />
      </Preloader>

      <Modal
        isOpen={user.isSubscriber && isEditName}
        close={() => {
          dispatch(setIsEditName(false))
        }}
      >
        <Formik
          initialValues={{
            surName: user.isName ? user.username.split(' ')[0] : '',
            firstName: user.isName ? user.username.split(' ')[1] : '',
          }}
          onSubmit={({ surName, firstName }) => {
            dispatch(changeFio(surName, firstName))
          }}
          //   validationSchema={validationSchema}
          enableReinitialize
        >
          {() => (
            <Form style={{
              alignItems: 'center', display: 'flex', flexDirection: 'column', textAlign: 'left',
            }}
            >
              <FieldFormik name="firstName" placeholder="Имя" label="Имя" />
              <FieldFormik name="surName" placeholder="Фамилия" label="Фамилия" />
              <Button htmlType="submit" type="primary">Сохранить</Button>
            </Form>
          )}
        </Formik>
      </Modal>
    </div>
  )
}
